/*
 * Copyright (c) 2022. Haodong JU
 */

import GlobalSettings from '@/GlobalSettings'
import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import Category from '../dish/Category'
import CategoryType from '../dish/CategoryType'

const entity = {
  code: {
    displayName: 'code',
  },
  name: {
    displayName: 'name',
  },
  categoryId: {
    displayName: 'labelName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname',
      },
    },
  },
  categoryTypeId: {
    displayName: 'dishesCategoryTypeId',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: CategoryType.getList,
      },
    },
  },
  price: {
    displayName: 'price',
  },
  totalCount: {
    // displayName: 'totalMoneyCount',
    tableConfig: {},
  },
}
const config = {
  load: async function (filter) {
    const data = {
      start: filter[0].dateFilter[0],
      end: filter[0].dateFilter[1],
    }
    return (await hillo.get('BackendData.php', Object.assign({
      op: 'dishStatistic',
      lang: GlobalSettings.getLang(),
    }, data)))
      .content
  },
}

export default IKDataEntity.ModelFactory(entity, config)
